import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HERO_IMG = "https://images.pexels.com/photos/28829796/pexels-photo-28829796.jpeg";

export const Hero = () => (
  <section id="top" className="relative flex min-h-[82vh] items-end" data-testid="mockup-hero">
    <img
      src={HERO_IMG}
      alt="Aerial view of green rooftops and winding roads where infrastructure meets nature"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div
      className="absolute inset-0 bg-gradient-to-r from-[#022A42]/85 via-[#022A42]/45 to-transparent"
      aria-hidden="true"
    />
    <div className="relative mx-auto w-full max-w-7xl px-6 pb-24 pt-40">
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="harc-heading max-w-3xl text-5xl font-light leading-[1.05] tracking-tight text-[#FFFFFF] md:text-7xl"
      >
        Where Science Creates Solutions
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-6 max-w-xl text-lg font-light leading-relaxed text-[#FFFFFF]/90 md:text-xl"
      >
        Turning insight into resilient infrastructure, sustainable growth, and a healthier
        environment.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="mt-10"
      >
        <Link
          to="/start-a-conversation"
          data-testid="hero-talk-to-harc"
          className="inline-flex items-center gap-3 rounded-full bg-[#FFA100] px-8 py-4 text-sm font-bold uppercase tracking-[0.12em] text-[#022A42] transition-colors hover:bg-[#D98A00]"
        >
          Talk to HARC <ArrowRight size={16} aria-hidden="true" />
        </Link>
      </motion.div>
    </div>
  </section>
);
